import { Box, Tooltip } from "@mui/material";
import { FC } from "react";
import styled from "styled-components";

interface ExtraStudyInfoProps {
  recordInfo: any;
  scans: {
    modality_code: string;
  }[]
}

const InfoName = styled.div`
  font-weight: 600;
  position: relative;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 25ch;
`;

const ExtraStudyInfo: FC<ExtraStudyInfoProps> = ({ recordInfo, scans }) => {
  const uniqueModality = Array.from(
    new Set(scans.map((item: any) => item?.modality_code))
  );
  return (
    <>
      <Box mt={1}>
        <div>UID</div>
        <Tooltip title={recordInfo?.study_id} arrow>
          <InfoName>{recordInfo?.study_id || "-"}</InfoName>
        </Tooltip>
      </Box>
      <Box display="flex" justifyContent="space-between" mt={1}>
        <Box>
          <div>Modality</div>
          <InfoName>{uniqueModality.join(",") || "-"}</InfoName>
        </Box>
        <Box>
          <div>Series</div>
          <InfoName>{scans.length || "-"}</InfoName>
        </Box>
      </Box>
      <Box mt={1}>
        <div>Description</div>
        <InfoName>{recordInfo?.description || "-"}</InfoName>
      </Box>
    </>
  );
};

export default ExtraStudyInfo;
